import { Link2, Undo2 } from 'lucide-react'

interface SharedAnchorBannerProps {
  companyName: string
  /** 共有された履歴のタイトル。未設定ならundefined（既定表示の「年月日と担当者名」は出さない） */
  title?: string
}

/**
 * 施主画面の最上部に出す「〇〇から共有された履歴」の帯（決定事項3。モックのCustomerLanding）。
 * 選択中の履歴がアンカーと同じときだけ出す。タイトル未設定の履歴では2行目を出さない
 * （既定表示の「年月日と担当者名」はお施主様に向けた表示ではない。藤井の指摘、2026-10-27）。
 */
export const SharedAnchorBanner: React.FC<SharedAnchorBannerProps> = ({ companyName, title }) => (
  <div
    className="flex items-center gap-2.5 rounded-lg border border-input bg-muted px-3 py-2.5"
    data-testid="shared-anchor-banner"
    role="status"
  >
    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-foreground text-background">
      <Link2 aria-hidden className="h-3.5 w-3.5" />
    </span>
    <div className="min-w-0 flex-1">
      <p className="text-[11px] text-muted-foreground">{companyName}から共有された履歴</p>
      {title ? <p className="truncate text-sm font-bold text-foreground">{title}</p> : null}
    </div>
  </div>
)

interface SharedAnchorReturnPillProps {
  /** 共有された履歴のタイトル。未設定ならundefined（「共有された履歴に戻る」になる） */
  title?: string
  onReturn: () => void
}

/**
 * 別の履歴を見ているときに画面下部へ固定で出す「共有された「タイトル」に戻る」のピル
 * （決定事項3。モックのCustomerBrowse）。
 */
export const SharedAnchorReturnPill: React.FC<SharedAnchorReturnPillProps> = ({
  title,
  onReturn,
}) => (
  <div className="pointer-events-none fixed inset-x-4 bottom-5 z-40 flex justify-center">
    <button
      className="pointer-events-auto inline-flex h-11 max-w-full items-center gap-2 rounded-full bg-foreground px-4 text-sm font-semibold text-background shadow-lg"
      onClick={onReturn}
      type="button"
    >
      <Undo2 aria-hidden className="h-3.5 w-3.5" />
      <span className="truncate">
        {title ? `共有された「${title}」に戻る` : '共有された履歴に戻る'}
      </span>
    </button>
  </div>
)
